<div  *ngIf="!showDeleteConfirmation">

<h1 class="text-title-4 mb-8">{{ 'passkey.profile.header' | translate }}</h1>
<div class="mb-24">
  <p class="mb-8 text-body-md">
   {{ 'passkey.profile.description' | translate }}
  </p>
  <!-- <p class="mb-8 text-body-md">
   {{ 'passkey.profile.subHeader' | translate }}
  </p> -->
</div>

 <div class="passkey-box ds-borders-sm mb-24">

  <div>
    <p class="passkey-list">
      <span class="rds-icon-passkey size-24"></span>
      <b style="margin-left: 5px;"> 
      {{ 'passkey.profile.passkeys' | translate }} 
      ({{ registeredPasskeys?.length > 0 ? registeredPasskeys?.length : 0  }})</b>
  </p>
 </div>

  <div *ngIf="registeredPasskeys?.length > 0;else nopasskeys">
    <div *ngFor="let item of registeredPasskeys ; let isLast = last" style="list-style-type:none;"
          class="mb-24">
        <span class="passkey-device">
          <p><ds-icon 
              class="size-24"
              [name]="item.PasskeyName.toLowerCase().includes('andriod') ? 'rds-icon-android' : 'rds-icon-apple'"> 
            </ds-icon>
          </p>
          <p class="ml-6"><b>{{item.PasskeyName}}</b></p>
        </span>
        <!-- <span class="passkey-item">
          <p>Password Manager: {{item.passkey_provider_name}}
          </p> 
          <p class="passkey-remove">
            <a style="display: inline-flex" href="javascript:void(0)" 
              (click)="onPasskeyRemove(item.registeredPasskeyid)" > 
            <p><ds-icon 
              class="ml-2 size-24"
              name="rds-icon-delete rds-icon-trash"> 
            </ds-icon>
          </p>
          </a>
        </p>
        </span> -->
        <span class="passkey-item">
          <p>{{ 'passkey.profile.createdDate' | translate }}: {{lang === 'en'? item.en_created_date :  item.fr_created_date}}
          </p> 

          <p class="passkey-remove">
            <a style="display: inline-flex" href="javascript:void(0)" 
              (click)="onPasskeyRemove(item.registeredPasskeyid)" > 
            <p><ds-icon 
              class="ml-2 size-24"
              name="rds-icon-delete rds-icon-trash"> 
            </ds-icon>
          </p>
          </a>
        </p>
        </span>
        <span class="passkey-item">
          <p>{{ 'passkey.profile.lastUsed' | translate }}: {{lang === 'en'? item.en_last_used :  item.fr_last_used}}
          </p>
        </span>
      <hr *ngIf="!isLast" class="passkey-hr mb-24 mt-24"/>
    </div>
  </div>
  <ng-template #nopasskeys>
    <div class="no-passkeys ds-body-r">
      <p class="no-passkeys-title">
        <strong>{{ 'passkey.profile.noPasskeys' | translate }}</strong>
      </p>
  
      <div class="bullet-item">
        {{ noPasskeyItem | translate }}
      </div>
  
      <div class="bullet-item">
        {{ 'passkey.profile.noPasskeyItem1' | translate }}
      </div>
    </div>
  </ng-template>
 </div>

 <h5 class="mb-16">{{ 'passkey.profile.more' | translate }}</h5>

  <ds-accordion>
      <ds-accordion-panel class="mb-24 text-body-sm" [data]="accountModalAccordion[0]">
        <div class="mb-16">
      {{ 'passkey.profile.safeDesc' | translate }}
        </div>
      </ds-accordion-panel>
    </ds-accordion>

      <button ds-button 
      variant="secondary"
      type="submit"
      role="button"
      class="w-30 mb-8 mt-16"
      (click)="onCancelPasskeyClick()"
      title="{{ 'passkey.profile.cancel' | translate }}">
      <span>{{ 'passkey.profile.cancel' | translate }}</span>
    </button>
    
</div>



  <div  *ngIf="showDeleteConfirmation">
    <div class="sb-open-container">
      <h1 class="text-title-4 mb-24">
        {{ 'passkey.profile.remove' | translate }}
      </h1>
      <p class="mb-8 ds-body-r mb-0">
        {{ warningMessage | translate }}
      </p>
      <p class="mb-8 ds-body-r mb-0">
        {{ 'passkey.profile.warningDesc' | translate }}
      </p>
  
      <div class="mb-8 ds-body-r mb-0" style="cursor: pointer;">
        <div>
          <a ds-link variant="cta" class="mt-4 ds-color-link"
           target="_blank" href="{{iosLink}}">{{ 'passkey.profile.ios' | translate }}
          <ds-icon class="ml-2 size-24" name="open-new"caption="iOS support"></ds-icon>  
        </a>
        </div>
        <div>
          <a ds-link variant="cta" class="mt-4 ds-color-link"
           target="_blank" href="{{andriodLink}}">{{ 'passkey.profile.android' | translate }}
          <ds-icon class="ml-2 size-24" name="open-new"caption="Android support"></ds-icon>   
          </a>
        </div>
        <div>
          <a ds-link variant="cta" class="mt-4 ds-color-link"
           target="_blank" href="{{chromeLink}}">{{ 'passkey.profile.chrome' | translate }}
          <ds-icon class="ml-2 size-24" name="open-new"caption="Google Chrome support"></ds-icon>   
          </a>
        </div>
        <div>
          <a ds-link variant="cta" class="mt-4 ds-color-link"
           target="_blank" href="{{edgeLink}}">{{ 'passkey.profile.edge' | translate }}
          <ds-icon class="ml-2 size-24" name="open-new"caption="Microsoft Edge support"></ds-icon>   
          </a>
        </div>
        <div>
          <a ds-link variant="cta" class="mt-4 ds-color-link"
           target="_blank" href="{{safariLink}}">{{ 'passkey.profile.safari' | translate }}
          <ds-icon class="ml-2 size-24" name="open-new"caption="Safari support"></ds-icon>   
          </a>
        </div>

      </div>
    </div>

    <div class="mt-16">
      <button ds-button
        type="button"
        role="button"
        class="w-30 mb-16"
        title="{{'passkey.profile.removePasskeyBtn' | translate}}"
        (click)="confirmPasskeyDelete()">
        <span>{{'passkey.profile.removePasskeyBtn' | translate}}</span>
      </button>

      <button ds-button
        variant="secondary"
        type="button"
        role="button"
        class="ml-8 w-30 mb-16"
        (click)="onCancelClick()"
        title="{{ 'passkey.profile.cancel' | translate }}">
        <span>{{ 'passkey.profile.cancel' | translate }}</span>
      </button>
    </div>
  </div>